import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable, NgZone, inject } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '@coin/shared/core/util-environments';
import { ToastrService } from 'ngx-toastr';
import { from, Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable()
export class UnauthorizedInterceptorService implements HttpInterceptor {
  private readonly router = inject(Router);
  private readonly toast = inject(ToastrService);
  private readonly ngZone = inject(NgZone);

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      catchError(err => {
        if (
          err.status === 403 &&
          !err.url.startsWith(environment.documentDownloadCloudfront) &&
          !err.url.includes('partner/dashboard')
        ) {
          if (!this.router.routerState.snapshot.url) {
            this.ngZone.run(() => this.router.navigate(['unauthorized']));
          } else {
            this.ngZone.run(() => this.toast.error(`Not authorized - ${request.url}`));
          }
          return from([err]);
        }
        return throwError(err);
      })
    );
  }
}
